import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

const ScrollToTopOnPathChange: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
export default ScrollToTopOnPathChange;
